import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';

export const headerStyle = {
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 0',
};

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: props.hidden,
    };
  }

  handleOpenClose = () => {
    const { hidden } = this.state;
    this.setState({
      hidden: !hidden,
    });
  };

  renderContent = () => {
    const { children, classes } = this.props;

    return (
      <div className={classes.content}>
        {React.Children.map(children, child => React.cloneElement(
          child,
        ))}
      </div>
    );
  };

  renderButton = () => {
    const { classes } = this.props;
    const { hidden } = this.state;

    return (
      <div className={classes.cta}>
        { hidden && (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 10.766L2.88669 5.16576C2.70097 4.96236 2.38048 4.94355 2.17084 5.12375C1.96121 5.30395 1.94182 5.61492 2.12754 5.81832L7.61541 11.8287C7.62345 11.8378 7.63189 11.8466 7.64072 11.8552C7.68321 11.8967 7.73168 11.9293 7.7836 11.9531C7.91947 12.0152 8.07892 12.0161 8.21641 11.9531C8.26833 11.9293 8.3168 11.8967 8.35928 11.8552C8.36811 11.8466 8.37655 11.8378 8.3846 11.8287L13.8725 5.81832C14.0582 5.61492 14.0388 5.30395 13.8292 5.12375C13.6195 4.94355 13.299 4.96236 13.1133 5.16576L8 10.766Z" fill="#232323" />
        </svg>
        )}

        {!hidden && (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5.234L13.1133 10.8342C13.299 11.0376 13.6195 11.0564 13.8292 10.8762C14.0388 10.696 14.0582 10.385 13.8725 10.1816L8.38459 4.1713C8.37655 4.1622 8.36811 4.1534 8.35928 4.1448C8.3168 4.1033 8.26833 4.0707 8.21641 4.04691C8.08053 3.98484 7.92108 3.98395 7.78359 4.04691C7.73167 4.0707 7.6832 4.1033 7.64072 4.1448C7.63189 4.1534 7.62345 4.1622 7.61541 4.1713L2.12754 10.1816C1.94182 10.385 1.96121 10.696 2.17084 10.8762C2.38048 11.0564 2.70097 11.0376 2.88669 10.8342L8 5.234Z" fill="#232323" />
        </svg>
        )}
      </div>
    );
  };

  render() {
    const { hidden } = this.state;
    const {
      headerTitle,
      className,
      classes,
    } = this.props;

    return (
      <div className={cn(className, classes.container)}>
        <div className={className.header} onClick={this.handleOpenClose} onKeyDown={e => e.key === 'ArrowDown' && this.handleOpenClose(e)} role="button" tabIndex="0">
          {/* eslint-disable-next-line react/prop-types */}
          <div className={className.title}>
            {headerTitle}
          </div>
          {this.renderButton(classes)}
        </div>
        {!hidden && this.renderContent()}
      </div>
    );
  }
}

Accordion.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  headerTitle: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.shape({
    header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }),
};

Accordion.defaultProps = {
  className: {
    header: headerStyle,
  },
  hidden: true,
};

export default injectSheet({
  '@keyframes easyIn': {
    '0%': { maxHeight: 0 },
    '100%': { maxHeight: 1000 },
  },
  header: headerStyle,
  content: {
    maxHeight: 'auto',
    padding: 0,
    animationName: 'easyIn',
    animationDuration: '0.5s',
  },
})(Accordion);
